/* Runs queued $(fn) callbacks once deferred jQuery has loaded. */
(function(){var q=window.pReady||[];window.pReady={push:function(f){jQuery(f);}};if(window.jQuery){for(var i=0;i<q.length;i++){jQuery(q[i]);}}})();
